import {gsap, ScrollTrigger} from "../LibrariesImport";
export default class DataAppearOnScroll {
	constructor() {
		const items = document.querySelectorAll("[data-aos]");

		items.forEach((item) => {
			// Attribut HTML `data-aos-delay`
			const delay = item.dataset.aosDelay ?? 0;
			const start = item.dataset.aosStart ?? "top 90%";

			ScrollTrigger.create({
				trigger: item,
				start: start,
				once: true,
				delay: parseFloat(delay),
				toggleClass: {
					targets: item,
					className: "appeared"
				}
			});

		});
	}
}
